<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <transition name="sidebarLogoFade">
      <!-- <p>{{collapse}}</p> -->
      <div v-if="collapse" class="sidebar-logo-link" @click="routerTo">
        <img src="https://zhizhiyy.oss-cn-hangzhou.aliyuncs.com/image/user-small-log.png" class="sidebar-logo-small" />
      </div>
      <div v-else class="sidebar-logo-link" @click="routerTo">
        <img src="https://zhizhiyy.oss-cn-hangzhou.aliyuncs.com/image/user-logo.png" class="sidebar-logo" />
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import { parseTime } from '@/utils'
// import path from 'path'
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      shopName: (state) => state.user.shopName,
      roles: (state) => state.user.roles,
      logo: (state) => state.user.logo,
      logo2: (state) => state.user.logo2
    })
  },
  methods: {
    dugeRolse(roles) {
      let str = ''
      if (roles.length <= 0) return
      switch (roles[0]) {
        case 'lower':
          str = '基础版'
          break
        case 'middle':
          str = '高级版'
          break
        case 'supper':
          str = '专业版'
          break
        case 'master':
          str = '内部版'
          break
        default:
          str = '基础版'
          break
      }
      return str
    },
    routerTo() {
      this.$store.commit('user/SET_TAB_INDEX', 0)
      this.$router.push('/home/homePage')
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  width: 100%;
  height: 50px;
  // background: $--color-primary;
  overflow: hidden;
  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    display: flex !important;
    justify-content: center;
    align-items: center;
    & .sidebar-logo-small {
      width: 50px;
      height: 50px;
      vertical-align: middle;
      -webkit-user-select: none;
      cursor: default;
      pointer-events: none;
    }
    & .sidebar-logo {
      width: 160px;
      height: 40px;
      margin-left: -10px;
      -webkit-user-select: none;
      cursor: default;
      pointer-events: none;
    }
    & .sidebar-title {
      flex: 1;
      display: inline-block;
      margin: 0;
      color: #fff;
      text-align: left;
      font-weight: 600;
      line-height: 20px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
      .d1 {
        margin-top: 14px;
        height: 40px;
        padding-right: 5px;
      }
      .d2 {
        line-height: 24px;
      }
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
